import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
createRoot(document.getElementById('root')!).render(<App data-id="element-1269" data-mp="1wc60qk3yhks7" />);